module.exports = __webpack_public_path__ + "static/media/joblist_grey.1cdeb09d.svg";